import { Grid } from "@mui/material";
import React from "react";
import type { FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import { MeasureDateRange } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { MetricField } from "../../../../../../../../../api/types/svTypes.ts";
import { getMetricRanges } from "../../../utils/dateRangeToString";
import DateRanges from "../measures/DateRanges";

interface Props {
  metric: MetricField;
  onClose: () => void;
  saveChanges: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  readonly: boolean;
}

export default function PeriodMenuItem({ metric, onClose, saveChanges, readonly }: Props) {
  const updateDateRangeType = React.useCallback(
    (newDateRangeType: MeasureDateRange) => {
      if (metric.config.dateRange === newDateRangeType) {
        onClose();
      } else {
        saveChanges({ dateRange: newDateRangeType }, false);
      }
    },
    [metric, onClose, saveChanges]
  );

  return (
    <Grid container sx={{ width: "100%" }}>
      <DateRanges
        dateRange={metric.config.dateRange ?? MeasureDateRange.NetChange}
        ranges={getMetricRanges()}
        onChange={updateDateRangeType}
        disabled={readonly}
      />
    </Grid>
  );
}
